import { Button, Form, Modal, Table, Switch } from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useInfoUser } from "../../store/UserStore";
import '../../styles/table.scss';
const ModalAddPropertyItem = ({
  count,
  setCount,
  attributeTemplate,
  propertyOptions,
  isModalOpen,
  handleCancel,
  propertyItems,
  setPropertyItems,
}) => {
  const { user, languageMap } = useInfoUser();

  const handleAddItem = (item) => {
    const newItem = {
      key: count,
      code: item.attributeTemplateCode,
      isActive: "Y",
      isHandleDelete: true,
      name: item[
        user.language === "us"
          ? "enName"
          : user.language === "vn"
            ? "vnName"
            : user.language === "kr"
              ? "krName"
              : item.enName
      ],
    };
    const updatedPropertyItems = [...propertyItems, newItem];
    setPropertyItems(updatedPropertyItems);
    setCount(count + 1);
  };

  const getAttribute = (typeCode) => {
    return propertyOptions.find((item) => item.code === typeCode)?.[
      { us: "enName", vn: "vnName", kr: "krName" }[user?.language]
    ];
  };

  return (
    <Modal
      title={
        languageMap?.["project.management.item.add.title"] ??
        "Add property items"
      }
      visible={isModalOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <div className="p-6">
        {attributeTemplate.map((item) => (
          <div
            className="flex justify-between items-center py-2"
            key={item.attributeTemplateCode}
          >
            <div className="font-bold w-[45%]">
              {user.language === "us"
                ? item.enName
                : user.language === "vn"
                  ? item.vnName
                  : user.language === "kr"
                    ? item.krName
                    : item.enName}
            </div>
            <div className="w-[40%]">{getAttribute(item.typeCode)}</div>
            <div className="text-center w-[30%]">
              <Button
                type="text"
                onClick={() => handleAddItem(item)}
                disabled={propertyItems.find(
                  (propertyItem) =>
                    propertyItem.code === item.attributeTemplateCode
                )}
              >
                <PlusOutlined />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

const TaskPropertyItem = ({
  initialValues,
  attributeTemplate,
  propertyOptions,
  permissionCurrentUser,
  different,
  propertyItems,
  setPropertyItems,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [count, setCount] = useState(0);
  const { user, languageMap } = useInfoUser();

  const columns = [
    {
      title: languageMap?.["project.management.item.name"] ?? "Name",
      dataIndex: "name",
      render: (_, record) => (
        <Form.Item
          name={["projectAttributeRequest", record.key, "attributeCode"]}
          initialValue={record.code}
          noStyle
        >
          {record.name}
        </Form.Item>
      ),
    },
    {
      title: "",
      dataIndex: "action",
      width: 70,
      render: (_, record) => {
        return !record?.isHandleDelete ? (
          <Switch
            disabled={
              different?.type === "UPDATED" &&
              !permissionCurrentUser?.includes("U")
            }
            size="small"
            checked={record?.isActive === "Y"}
            onChange={() => handleChangeActive(record.key, record.code)}
          />
        ) : (
          <Button
            disabled={
              different.type === "UPDATED" &&
              !permissionCurrentUser?.includes("U")
            }
            onClick={() => handleDelete(record.key)}
            type="text"
          >
            <DeleteOutlined className="text-[red]" />
          </Button>
        );
      },
    },
  ];

  const handleDelete = (key) => {
    const newPropertyItems = propertyItems.filter((item) => item.key !== key);
    setPropertyItems(newPropertyItems);
  };

  const handleChangeActive = (key, code) => {
    const updatedPropertyItems = propertyItems?.map((item) => {
      if (item?.key === key) {
        return { ...item, isActive: item?.isActive === "Y" ? "N" : "Y" };
      }

      return item;
    });

    setPropertyItems(updatedPropertyItems);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (initialValues.type === "UPDATED") {
      setPropertyItems(
        initialValues.projectAttributeRequest.map((item, index) => {
          let getName = attributeTemplate.find(
            (element) => element.attributeTemplateCode === item.attributeCode
          ).enName;
          let name =
            languageMap?.[
              `project.management.item.add.${getName.toLowerCase().replace(/ /g, "_")}`
            ] ?? item.enName;
          return {
            key: index,
            code: item?.attributeCode,
            isActive: item?.isActive,
            // name:  attributeTemplate.find(element => element.attributeTemplateCode === item.attributeCode).enName,
            name: name,
          };
        })
      );
      setCount(initialValues.projectAttributeRequest.length);
    }
  }, [initialValues]);

  return (
    <>
      <div className="flex justify-between items-center pb-4">
        <span className="font-bold">
          {languageMap?.["project.management.item"] ?? "Task property Items"}
        </span>
        <Button
          disabled={
            different.type === "UPDATED" &&
            !permissionCurrentUser?.includes("U")
          }
          type="primary"
          onClick={showModal}
        >
          {languageMap?.["project.management.item.addProperty"] ??
            "Add item property +"}
        </Button>
      </div>
      <Table
        className="custom-table-scroll"
        columns={columns}
        dataSource={propertyItems}
        pagination={false}
        style={{ height: 250 }}
        scroll={{
          y: 180,
        }}
      />
      {isModalOpen && (
        <ModalAddPropertyItem
          count={count}
          setCount={setCount}
          attributeTemplate={attributeTemplate}
          propertyOptions={propertyOptions}
          isModalOpen={isModalOpen}
          handleCancel={handleCancel}
          propertyItems={propertyItems}
          setPropertyItems={setPropertyItems}
        />
      )}
    </>
  );
};

export { TaskPropertyItem };
